export enum PurchasingPlanStatusENUM {
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  OVERDUE = "OVERDUE",
  INCOMPLETE = "INCOMPLETE",
  TOTALLY_COMPLETED = "TOTALLY_COMPLETED",
}
